import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { LinkWithScroll } from "common/components/LinkWithScroll";
import React, { useContext } from "react";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";

const Section = ({ data, index }) => {
  const { language } = useContext(LanguageContext);
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isEven = index % 2 === 0;

  return (
    <Box
      py={{ xs: 6, md: 8 }}
      sx={{
        backgroundColor: isEven ? "transparent" : "var(--clr-warm-bg)",
        overflowX: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Grid
          display="grid"
          container
          columnSpacing={{ xs: 2, md: 8 }}
          alignItems="center"
          gridTemplateColumns={{
            xs: "1fr",
            md: "1fr 1fr",
          }}
          gridTemplateAreas={
            data.imageFirst
              ? { xs: '"col1" "col2"', md: '"col1 col2"' }
              : { xs: '"col1" "col2"', md: '"col2 col1"' }
          }
        >
          {/* IMAGE */}
          <Grid item gridArea="col1">
            <Box
              display="flex"
              sx={{
                justifyContent: {
                  xs: "center",
                  md: data.imageFirst ? "left" : "right",
                },
                overflow: "hidden",
                "&:hover img": {
                  transform: "scale(1.03)",
                },
              }}
            >
              <img
                src={require(`../../../assets/images/${data.image}`)}
                alt={data.title}
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  objectFit: "cover",
                  display: "block",
                  transition: "transform 0.8s ease",
                }}
              />
            </Box>
          </Grid>

          {/* TEXT */}
          <Grid item gridArea="col2" mt={{ xs: 4, md: 0 }}>
            <Box
              display="flex"
              flexDirection="column"
              height="100%"
              justifyContent="center"
            >
              {/* Gold accent line */}
              <Box
                sx={{
                  width: 50,
                  height: "2px",
                  background: "var(--clr-primary)",
                  mb: 2,
                  mx: isFullWidth ? "auto" : 0,
                }}
              />
              <Typography
                color="primary"
                sx={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontWeight: 500,
                  fontSize: { xs: "1.3rem", md: "1.5rem" },
                  letterSpacing: "0.08em",
                  textAlign: { xs: "center", md: "left" },
                  mb: { xs: 1.5, md: 2 },
                }}
              >
                {data.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  lineHeight: 1.9,
                  fontSize: { xs: "0.9rem", md: "0.95rem" },
                  color: "#4a4a4a",
                  mb: { xs: 3, md: 4 },
                }}
              >
                {data.text}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <LinkWithScroll
                  to={data.link}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth={isFullWidth}
                    sx={{
                      borderRadius: 0,
                      px: 4,
                      py: 1,
                      fontFamily: "'Lato', sans-serif",
                      fontWeight: 400,
                      letterSpacing: "0.1em",
                      fontSize: "0.8rem",
                      minWidth: isFullWidth ? "100%" : "auto",
                    }}
                  >
                    {language === "pt" ? "Ver no Mapa" : "See on the Map"}
                  </Button>
                </LinkWithScroll>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Section;
